import React, { useEffect, useState } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { Features } from "@musicfy/contants/Features";
import { useSubscriptionContext } from "@musicfy/libs/SubscriptionProvider";
import { canUseFeature } from "@musicfy/utils";

import AdvancedSettingsTakeover from "./AdvancedSettingsTakeover";
import { type TInferenceSettings } from "../types";

interface IAdvancedSettingsProps {
  inferenceSettings: TInferenceSettings;
  setInferenceSettings: React.Dispatch<
    React.SetStateAction<TInferenceSettings>
  >;
}

const AdvancedSettings = ({
  inferenceSettings,
  setInferenceSettings,
}: IAdvancedSettingsProps): JSX.Element => {
  const { subscription, isLoading } = useSubscriptionContext();

  const [isTakeoverOpen, setIsTakeoverOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!isLoading) {
      if (canUseFeature(Features.MASTER_QUALITY, subscription)) {
        setInferenceSettings((prev) => {
          return { ...prev, f0Method: "rmvpe" };
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription, isLoading]);

  return (
    <div className="z-30 w-full rounded-12 px-6 py-4 bg-white/2 border border-white/20">
      <div
        className="flex h-full w-full cursor-pointer items-center justify-between"
        role="button"
        tabIndex={0}
        aria-label="Open Advanced Settings Modal"
        onClick={(e) => {
          e.stopPropagation();
          setIsTakeoverOpen(true);
        }}
      >
        <div className="capitalize">Advanced Settings</div>
        <ArrowDropDownIcon />
      </div>
      <AdvancedSettingsTakeover
        isOpen={isTakeoverOpen}
        onClose={() => setIsTakeoverOpen(false)}
        inferenceSettings={inferenceSettings}
        setInferenceSettings={setInferenceSettings}
      />
    </div>
  );
};

export default AdvancedSettings;
